import usePostData from '../../../../../hooks/postHook';

export const useSendAuthenticationFeedback = () => {
  const [{ data, body, isLoading, isError, error }, doSendFeedback] =
    usePostData('');

  return { data, body, isLoading, isError, error, doSendFeedback };
};
